export default {
    items: [
        // {
        //     name: "Dashboard",
        //     url: "/dashboard",
        //     icon: "fa fa-dashboard",
        //     permission: null,
        // },
        {
            name: "Daftar Order",
            url: "/order",
            icon: "fa fa-shopping-bag",
            permission: null,
        },
        {
            name: "Carousel Promo",
            url: "/carousel",
            icon: "fa fa-picture-o",
            permission: null,
        },
        {
            name: "Divisi Barang",
            url: "/divisi",
            icon: "fa fa-folder-open",
            permission: null,
        },
        {
            name: "Pengaturan Tipe",
            url: "/tipe",
            icon: "fa fa-cubes",
            permission: null,
        },
        // {
        //     name: "Daftar Items",
        //     url: "/items",
        //     icon: "fa fa-cube",
        //     permission: null,
        // },
        {
            name: "Grosir / Eceran",
            url: "/grosir-eceran",
            icon: "fa fa-balance-scale",
            permission: null,
        },
        // {
        //     name: "Asuransi HP",
        //     url: "/dashboard",
        //     icon: "fa fa-briefcase",
        //     permission: null
        // },
        // {
        //     name: "Daftar Pembeli",
        //     url: "/users",
        //     icon: "fa fa-users",
        //     permission: null,
        // },
        {
            name: "Payment Gateway",
            url: "/payment-gateways",
            icon: "fa fa-credit-card-alt",
            permission: null,
        },
        {
            name: "Shipment Gateway",
            url: "/shipment-gateways",
            icon: "fa fa-truck",
            permission: null,
        },
        // {
        //     name: "Resolusi Keluhan",
        //     url: "/dashboard",
        //     icon: "fa fa-comments",
        //     permission: null
        // },
        {
            name: "Administrasi",
            url: "/admin",
            icon: "fa fa-user-circle",
            permission: 1,
        },
        {
            name: "Alamat & Sistem",
            url: "/address-system",
            icon: "fa fa-cog",
            permission: 1,
        },
        {
            name: "Sinkron Master Data",
            url: "/sync-master",
            icon: "fa fa-refresh",
            permission: 1,
        },
    ],
};
